"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractDisplayName = exports.possessiveForm = exports.hasDecimals = exports.currency = exports.durationCompact = exports.duration = exports.integer = exports.decimal = exports.yearMonth = exports.monthName = exports.month = exports.monthMm = exports.dateTimeMs = exports.dateTime = exports.date = void 0;
const dateformat_1 = __importStar(require("dateformat"));
const moment_1 = __importDefault(require("moment"));
const moment_duration_format_1 = __importDefault(require("moment-duration-format"));
const numeral_1 = __importDefault(require("numeral"));
const dates_1 = require("./dates");
// @ts-ignore
(0, moment_duration_format_1.default)(moment_1.default); // configure the duration formatter plugin
const DATE_FORMAT = 'yyyy-mm-dd';
const DATE_TIME_FORMAT = 'yyyy-mm-dd HH:MM:ss';
const DATE_TIME_MS_FORMAT = 'yyyy-mm-dd HH:MM:ss.l';
const dateFormat = (date, format, useUTC) => {
    try {
        if (!date) {
            throw new Error('Empty date');
        }
        return (0, dateformat_1.default)(date, format, useUTC);
    }
    catch (e) {
        return 'Invalid date';
    }
};
const date = (date) => dateFormat(date, DATE_FORMAT);
exports.date = date;
const dateTime = (date, useUTC) => dateFormat(date, DATE_TIME_FORMAT, useUTC);
exports.dateTime = dateTime;
const dateTimeMs = (date, useUTC) => dateFormat(date, DATE_TIME_MS_FORMAT, useUTC);
exports.dateTimeMs = dateTimeMs;
const monthMm = (date) => (0, dateformat_1.default)(date, 'mm');
exports.monthMm = monthMm;
const month = (date) => (0, dateformat_1.default)(date, 'mmmm');
exports.month = month;
const monthName = (mm) => dateformat_1.i18n.monthNames[Number(mm) - 1] || 'Invalid Month: ' + mm;
exports.monthName = monthName;
const yearMonth = (yyyymm) => (0, exports.monthName)(yyyymm.toString().substring(4, 6)) + ' ' + yyyymm.toString().substring(0, 4);
exports.yearMonth = yearMonth;
const decimal = (number, hasTrailingZeros = true) => {
    if (number !== undefined && (hasTrailingZeros || (0, exports.hasDecimals)(number))) {
        return (0, numeral_1.default)(number).format('0,0.00').replace(/,/g, ' ').replace('.', ',');
    }
    else {
        return (0, exports.integer)(number);
    }
};
exports.decimal = decimal;
const integer = (number) => number === undefined ? '' : (0, numeral_1.default)(number).format('0,0').replace(/,/g, ' ');
exports.integer = integer;
const duration = (duration) => isString(duration) && !(0, dates_1.isValidDuration)(duration)
    ? 'Invalid duration'
    : moment_1.default.duration(duration).format('y [y] w [w] d [d] h [h] m [m] s [s] S [ms]', {
        trim: 'both',
    });
exports.duration = duration;
const durationCompact = (value, maxUnits = 2) => {
    const fullDuration = (0, exports.duration)(value);
    const splitDuration = fullDuration.split(' ');
    const maxSpaces = maxUnits * 2 - 1;
    return fullDuration === 'Invalid duration'
        ? 'Invalid'
        : splitDuration.length > maxSpaces + 1
            ? splitDuration
                .filter((_, i) => i <= maxSpaces)
                .join(' ')
                .concat('...')
            : fullDuration;
};
exports.durationCompact = durationCompact;
const integerWithDash = (number, hasTrailingDash) => hasTrailingDash ? (0, exports.integer)(number) + ',-' : (0, exports.integer)(number);
const currency = (number, symbol = '€$£', showDecimals, hasTrailingDash) => {
    const value = (showDecimals !== undefined ? showDecimals : (0, exports.hasDecimals)(number)) && (!hasTrailingDash || (0, exports.hasDecimals)(number))
        ? (0, exports.decimal)(number)
        : integerWithDash(number, hasTrailingDash);
    return `${symbol} ${value}`;
};
exports.currency = currency;
const hasDecimals = (number) => number !== undefined && number % 1 !== 0;
exports.hasDecimals = hasDecimals;
const possessiveForm = (str) => {
    return str && ((str === null || str === void 0 ? void 0 : str.slice(-1).toLowerCase()) === 's' ? str + "'" : str + "'s");
};
exports.possessiveForm = possessiveForm;
const format = {
    date: exports.date,
    dateTime: exports.dateTime,
    dateTimeMs: exports.dateTimeMs,
    month: exports.month,
    monthMm: exports.monthMm,
    monthName: exports.monthName,
    yearMonth: exports.yearMonth,
    decimal: exports.decimal,
    integer: exports.integer,
    duration: exports.duration,
    durationCompact: exports.durationCompact,
    hasDecimals: exports.hasDecimals,
    currency: exports.currency,
    possessiveForm: exports.possessiveForm,
};
exports.default = format;
const contractDisplayName = (c) => `${c.id} ${c.name ? `- ${c.name}` : ''}`;
exports.contractDisplayName = contractDisplayName;
function isString(value) {
    return typeof value === 'string' || value instanceof String;
}
